import { render, staticRenderFns } from "./WuziManage.vue?vue&type=template&id=19ea9af4&scoped=true"
import script from "./WuziManage.vue?vue&type=script&lang=js"
export * from "./WuziManage.vue?vue&type=script&lang=js"
import style0 from "./WuziManage.vue?vue&type=style&index=0&id=19ea9af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea9af4",
  null
  
)

export default component.exports